import {CLEAR_CREATE_TABLE} from '../_CONSTANTS';

export const clear_Create_Table = () => {
  return ({
    type: CLEAR_CREATE_TABLE,
    payload: {}
  })
}
